import { signIn } from '../lib/supabase.js';
import { err } from '../components/toast.js';

export function renderLogin() {
  window.__pageInit = attachLogin;
  return `
    <div class="login-box">
      <div class="login-brand">
        <h1>VNEC v9</h1>
        <p class="muted">VINAENC ERP — Đăng nhập</p>
      </div>
      <form id="login-form" class="login-form">
        <label class="field"><span>Email</span>
          <input type="email" name="email" required autocomplete="email" autofocus>
        </label>
        <label class="field"><span>Mật khẩu</span>
          <input type="password" name="password" required autocomplete="current-password" minlength="6">
        </label>
        <button type="submit" class="btn btn-primary btn-block">Đăng nhập</button>
      </form>
      <div class="login-footer">
        <p class="muted small">Quên mật khẩu? Liên hệ quản trị viên.</p>
      </div>
    </div>`;
}

function attachLogin() {
  const form = document.getElementById('login-form');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.textContent = 'Đang đăng nhập...';
    try {
      const fd = new FormData(form);
      await signIn(fd.get('email'), fd.get('password'));
      window.location.hash = '#/dashboard';
    } catch (e) {
      err('Đăng nhập thất bại: ' + e.message);
      btn.disabled = false;
      btn.textContent = 'Đăng nhập';
    }
  });
}
